import styled from "styled-components";


export const AppContainer = styled.main`
    
    width: min(300px,400px);
    margin: 20px auto;
`